<template>
    <div class="content-header">
        <div class="shadow-layout">
            <div class="position-absolute box-layout">
                <div class="box-load">
                    <div id="loading" class="loader"></div>
                    <div class="text-load">Loading</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Loading',
    data () {
        return {
        };
    },
    computed: {
    },
    created () {
    },
    methods: {
    },
};
</script>



// WEBPACK FOOTER //
// src/views/common/Loading.vue